
































import { Component, Mixins, Prop } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import Context from "@/mixins/context";
import ForgottenPasswordFields from "@/components/app/global/auth/forgottenPasswordFields.vue";
import { BSnackbarConfig } from "buefy/types/components";
import { IClient } from "@/models/clients";

@Component({
  components: { ForgottenPasswordFields }
})
export default class ForgottenPasswordModal extends Mixins(
  HasValidation,
  Context
) {
  @Prop({ default: "" })
  public username!: IClient["username"];

  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
    forgottenPasswordFields: ForgottenPasswordFields;
  };
  public isProcessing = false;
  public form = {
    username: this.username,
    token: ""
  };

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) throw this.$t("_.form_invalid");
      await this.$refs.forgottenPasswordFields.resetPassword();
      this.$buefy.snackbar.open({
        message: this.$t("_sentence.password_reset_requested"),
        position: "is-bottom",
        queue: false,
        duration: 10000
      } as BSnackbarConfig);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
